import React, { Component } from 'react';
import logo from './logo_big.svg';
import { Navbar, Nav, NavItem, MenuItem, NavDropdown } from 'react-bootstrap';
import ReactDOM, {render} from 'react-dom';
import {Link} from 'react-router-dom';
import './App.css';
import $ from 'jquery';
var self = this;

class Header extends Component {
    constructor(props){
        super(props);

    }

    componentDidMount() {
        $( "#prodej-instalace-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#lokalni-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#outsourcing-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#audit-is-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#webhosting-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#webdesign-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });
        $( "#cenik-praci-li" ).click(function() {
            $( ".dropdown" ).addClass("deactived");
        });

        $(".dropdown").mouseover(function(){
            $( ".dropdown" ).removeClass("deactived");
        });


    }
    shouldComponentUpdate (nextProps, nextState) {
        return false;
    }

  render() {
    return (
<div>

    <header className="header">
        <div className="container header-container">
           {/* <img src="/ozdoba3.png" className="ozdoba"/>*/}

            <Navbar className="navbar navbar-expand-lg navbar-light bg-light" collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">
                            <img src={logo} className="menu-logo" alt="logo" />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>

                <Navbar.Collapse>
                        <Nav className="main-menu-ul">

                            <NavItem eventKey={1} href="/">
                                <li id="home"><Link to="/">Home</Link></li>
                            </NavItem>



                            <NavDropdown eventKey={3} title="Služby a produkty" id="basic-nav-dropdown">
                                <div className="dropdown-content">

                                <MenuItem eventKey={3.1} href="/sluzby-a-produkty/lokalni-a-vzdalena-sprava-siti"><li id="lokalni-li" className="menuLI">Lokální a vzdálená správa sítí</li></MenuItem>
                                <MenuItem eventKey={3.2} href="/sluzby-a-produkty/outsourcing-is-it"><li id="outsourcing-li" className="menuLI">Outsourcing IS/IT</li></MenuItem>
                                <MenuItem eventKey={3.3}  href="/sluzby-a-produkty/audit-is-kontrola-legalnosti-sw" ><li className="menuLI" id="audit-is-li">Audit IS - kontrola legálnosti SW</li></MenuItem>
                                <MenuItem eventKey={3.3}  href="/sluzby-a-produkty/prodej-instalace-servis-hw-sw"><li className="menuLI" id="prodej-instalace-li">Prodej, instalace a servis HW a SW</li></MenuItem>
                                <MenuItem eventKey={3.4}  href="/sluzby-a-produkty/webhosting"><li id="webhosting-li" className="menuLI">Webhosting</li></MenuItem>
                                <MenuItem eventKey={3.4}  href="/sluzby-a-produkty/webdesign"><li id="webdesign-li" className="menuLI">Webdesign</li></MenuItem>
                                <MenuItem eventKey={3.4}  href="/sluzby-a-produkty/cenik-praci-a-sluzeb"><li id="cenik-praci-li" className="menuLI">Ceník prací a služeb</li></MenuItem>

                                </div>
                            </NavDropdown>

                            <NavItem eventKey={4} href="/o-firme" id="o-firme-li">
                                <li id="o-firme-li" className="dropbtn"><a>O firmě</a></li>
                            </NavItem>

                            <NavItem eventKey={5} href="/reference">
                                <li id="reference-li" className="dropbtn"><a>Reference</a></li>
                            </NavItem>

                            <NavItem eventKey={6} href="/podpora">
                                <li id="podpora-li" className="dropbtn"><a>Podpora</a></li>
                            </NavItem>

                            <NavItem eventKey={7} href="/kontakty">
                                <li id="kontakty-li" className="dropbtn"><a>Kontakty</a></li>
                            </NavItem>

                        </Nav>
                </Navbar.Collapse>
            </Navbar>

        </div>



    </header>

</div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js